import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["chevronCollapsed", "chevronExpanded"]

  connect() {
    this.applyExpandedState(this.isExpanded())
    this.#defaultProgrammaticFocusToPreventScroll()
  }

  toggle(event) {
    event.preventDefault()
    const willExpand = !this.isExpanded()
    this.element.setAttribute("aria-expanded", willExpand.toString())
    this.applyExpandedState(willExpand)
  }

  applyExpandedState(expanded) {
    const detailRow = this.detailRow()
    if (!detailRow) return

    detailRow.classList.toggle("hidden", !expanded)
    this.chevronCollapsedTarget.classList.toggle("hidden", expanded)
    this.chevronExpandedTarget.classList.toggle("hidden", !expanded)
  }

  isExpanded() {
    return this.element.getAttribute("aria-expanded") === "true"
  }

  detailRow() {
    const id = this.element.getAttribute("aria-controls")
    return id ? document.getElementById(id) : null
  }

  // Turbo's stream rendering re-focuses this chevron after every morph
  // via a bare `.focus()` — which scrolls the viewport. Default
  // programmatic focus to preventScroll; keyboard focus bypasses JS.
  #defaultProgrammaticFocusToPreventScroll() {
    const originalFocus = HTMLElement.prototype.focus
    this.element.focus = function(options) {
      return originalFocus.call(this, { preventScroll: true, ...options })
    }
  }
}
